export const REDO_ACCOUNT_HASH = "#redo";
export const REDO_HOME_HASH = "#redo-home";
export const REDO_REVIEW_HASH = "#redo-review";
